import { Button, Skeleton, Tooltip, lucideIcons, tableHelpers } from '@round/creatorbase-ui';
import { useAddCreatorToPoolPendingAccounts } from '@round/creatorbase-helpers/api-hooks';
import { CellContext } from 'Modules/Plans/CreatorSearch/components/CreatorExploreTable/helpers';
import { PlatformIcon, platformLabels } from 'Modules/Plans/helpers';
import { getTableMeta } from '../../helpers';
import styles from './AddToPoolCell.module.css';

const { Check, Plus } = lucideIcons;

export const AddToPoolCell = ({ row: { original }, table }: CellContext) => {
    const { getCreatorPoolAccounts, poolId, onCreatorAdd } = getTableMeta(table);
    const pendingAccountIds = useAddCreatorToPoolPendingAccounts(poolId);

    if (tableHelpers.isLoadingRow(original)) {
        return <Skeleton className={styles.skeleton} />;
    }

    const { memberPlatforms, accountIdsToAdd } = getCreatorPoolAccounts(original);

    if (!accountIdsToAdd.length) {
        return (
            <span className={styles.added}>
                <Check className={styles.addedIcon} />
                Added
            </span>
        );
    }

    const isPending = accountIdsToAdd.some((accountId) => pendingAccountIds.includes(accountId));

    return (
        <div className={styles.actions}>
            {/* A creator can hold one account in the pool and one outside it, so say which is already in. */}
            {memberPlatforms.map((platform) => {
                const label = `${platformLabels[platform]} account is already in this pool`;

                return (
                    <Tooltip key={platform}>
                        <Tooltip.Trigger className={styles.memberPlatform} aria-label={label}>
                            <PlatformIcon platform={platform} />
                        </Tooltip.Trigger>
                        <Tooltip.Content>{label}</Tooltip.Content>
                    </Tooltip>
                );
            })}

            <Button
                size="xs"
                variant="outline"
                // The button holds one icon at a time: the plus gives way to the pending spinner.
                isLoading={isPending}
                disabled={isPending}
                onClick={() => onCreatorAdd(original)}
            >
                {isPending ? null : <Plus />}
                Add
            </Button>
        </div>
    );
};
